"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperfluidDestructorMock__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        stateMutability: "nonpayable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "NON_UPGRADABLE_DEPLOYMENT",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x60a06040526000608052348015601457600080fd5b50608051609c61002d600039600060300152609c6000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063cd312ec414602c575b6000ff5b60527f000000000000000000000000000000000000000000000000000000000000000081565b604051901515815260200160405180910390f3fea2646970667358221220e19c9af11f89ff5b9cdbe7cd15f92e6e9de562374bf7901b87cb2747ddaa874364736f6c63430008100033";
const isSuperArgs = (xs) => xs.length > 1;
class SuperfluidDestructorMock__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SuperfluidDestructorMock__factory = SuperfluidDestructorMock__factory;
SuperfluidDestructorMock__factory.bytecode = _bytecode;
SuperfluidDestructorMock__factory.abi = _abi;
//# sourceMappingURL=SuperfluidDestructorMock__factory.js.map